import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import Cookie from '@/util/cookie'
Vue.use(VueAxios,axios);
	// let token = ''
	// if(window.sessionStorage.getItem('token')){
	// 	token =window.sessionStorage.getItem('token_type') + ' ' + window.sessionStorage.getItem('token')
	// }
	// console.log(token,1)
const requests = axios.create({
  timeout: 100000,
  
  // baseURL: 'https://app.annengyunshu.com/api/',  // 正式
  // baseURL: 'https://annengyunshu.jishu12.com/api/',  // 测试
  // baseURL: 'http://10.10.11.189:8032/api/', //测试
  baseURL: 'https://api.ezlunch.club/api/m14260/', //测试
  
  headers: {
	'Content-Type': 'application/json',
	 // 'Content-Type': 'application/json;charset=UTF-8;',
    // 'content-type':  'application/x-www-form-urlencoded',
	// 'lang': window.sessionStorage.getItem('locale') == 'en' ? 'en' : 'zh-Hans'
	
	// 'authorization': token
  },
  
})
requests.interceptors.request.use((config) => {
// console.log(window.sessionStorage.getItem('locale'),'语言包《----------------')
	// if(config.url == 'user/login' || config.url == 'sms/aliSend' || config.url == 'user/mobileLogin'){
	// 	let a = {
	// 		'content-type':  'application/x-www-form-urlencoded',
	// 	}
	// 	config.headers = Object.assign({}, a)
	// }
	let token = ''
	if(window.sessionStorage.getItem('token')){
		// console.log(window.sessionStorage.getItem('token'),111111)
		// token =window.sessionStorage.getItem('token_type') + ' ' + window.sessionStorage.getItem('token')
		config.headers['user-token'] = window.sessionStorage.getItem('token');
	}
	config.headers['lang'] =  window.sessionStorage.getItem('locale') == 'en' ? 'en' : 'zh-Hans'
	// console.log(window.sessionStorage.getItem('token'),2)
  // config.headers['Authorization'] =1234;
  return config;
})
// console.log(requests,1111111111)
requests.interceptors.response.use((res) => {

  if(res.data.code == '-201' || res.data.code == '-202' || res.data.code == '-203' || res.data.code == '5' ){
	  window.sessionStorage.setItem('token', '');
	  window.sessionStorage.setItem('user','');
    window.location.href = 'https://api.ezlunch.club/pc/index.html#/menu';
	// this.$router.push({
	// 	name: 'login',
	// 	// params: page,
	// });
    return Promise.reject(res.data);
  }else{
    return res.data;
  }
}, (error) => {
  return Promise.reject(error)
})

export default requests;